// extracted by mini-css-extract-plugin
export default {"conteneur_titre_page":"titre-page_conteneur_titre_page__kzerJ","titre_page":"titre-page_titre_page__POtZ3","titre_section":"titre-page_titre_section__EDPRp"};